export const en = {
    'name-cis-time-zone': 'CIS',
    'name-russia-time-zone': 'Russia',
    'name-world-time-zone': 'Worldwide'
};
